export default "__VITE_ASSET__b6P93sHi__"